import React from "react";
import {
  ALERT_TIMEOUT,
  MIN_AI_TEXT_LENGTH,
  STATUS_CHECK_INTERVAL,
  ThemeButtonSummaryBG,
} from "../Config";
import { useState, useContext, useRef, useEffect } from "react";
import { REQUEST_URL } from "../Config";
import { useNavigate } from "react-router";
import { formatSecondsToMS } from "../Utils";
import { copyTextToClipboard } from "../Utils";
import { LoggedInContext } from "../../App";

function SummarizerContent() {
  //navigate
  const navigate = useNavigate(); //react router navigate

  //time to show time value
  //initialise with 2 minutes
  const [time, setTime] = useState(60 * 2);

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //delay time
  //delay to run the code in runpod server i.e in queue time
  //execution time
  //time taken to execute the code
  //total time is = delayTime + executionTime
  var process_time = useRef({
    delayTime: 0.0,
    executionTime: 0.0,
  });

  //timer id
  const timerId = useRef();

  //
  //get ai detector values
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line
  const { maxAITextLength } = useContext(LoggedInContext);

  //submit form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);

  //result loadedstate
  const [resultLoaded, setResultLoaded] = useState(false);

  //summarize texts form values
  //mode 1 == short
  //mode 2 = medium
  //mode 3 = long
  const [summarizeTextsValues, setSummarizeTextsValues] = useState({
    enter_main_text: "",
    summarized_text: "",
    mode: 2,
  });

  //use effect to handle the submit button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked === true) {
      //reset
      process_time.delayTime = 0.0;
      process_time.executionTime = 0.0;

      //call api to summarize the text
      summarizeTextsAPICall();
      //time for time remaiming
      timerId.current = setInterval(
        () => setTime((time) => Math.max(0, time - 1)),
        1000
      );
    } else {
      //clear
      clearInterval(timerId.current);
      //reset
      setTime(60 * 2);
    }
    //if result loaded
    if (resultLoaded === true) {
      //update search history
      updateSearchHistory();
    }

    //cleanup
    return () => clearInterval(timerId); // Cleanup on unmount

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked, resultLoaded]);

  //check status from status from endpoint
  const checkRunpodJobStatus = async (job_id) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "STATUS_CHECK_SUMMARIZER",
        text_to_process: "",
        job_id: job_id, // can be used for tracking jobs
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //check success
        if (data.success === true) {
          //check status
          if (data.status === "COMPLETED") {
            //hide the spinner
            setSubmitClicked(false);
            //result json
            const result = JSON.parse(data.message);
            // Update the state with the new value
            setSummarizeTextsValues({
              ...summarizeTextsValues,
              summarized_text:
                result.text.length > 0
                  ? result.text[0]
                  : summarizeTextsValues.enter_main_text,
            });

            //set time
            process_time.delayTime = data.delay_time;
            process_time.executionTime = data.execution_time;

            //set
            setResultLoaded(true);
          } else if (
            data.status === "FAILED" ||
            data.status === "CANCELLED" ||
            data.status === "TIMED_OUT"
          ) {
            //hide the spinner
            setSubmitClicked(false);

            //set alert state to show error
            setAlert({
              type: "danger",
              message: "Failed to summarize text. Please try again.",
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT);
          } else if (
            data.status === "IN_QUEUE" ||
            data.status === "RUNNING" ||
            data.status === "IN_PROGRESS"
          ) {
            //check api after 10 seconds
            setTimeout(() => {
              //callback
              checkRunpodJobStatus(job_id);
            }, STATUS_CHECK_INTERVAL);
          }
        } else {
          //hide the spinner
          setSubmitClicked(false);
          //scroll to top
          window.scrollTo(0, 0);
          //set alert state to show error
          setAlert({
            type: "danger",
            message:
              data.message || "Failed to summarize text. Please try again.",
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //hide the spinner
        setSubmitClicked(false);

        //set alert state to show error
        setAlert({
          type: "danger",
          message: "Failed to summarize text. Please try again.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
      });
  };

  //summarize texts from endpoint
  const summarizeTextsAPICall = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the summarized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "SUMMARIZE_TEXTS",
        text_to_process: summarizeTextsValues.enter_main_text,
        mode: summarizeTextsValues.mode,
        job_id: null, // can be used for tracking jobs
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //set token in local storage
        localStorage.setItem("access_token", data.token);
        //check if the response is successful
        //and job is send to runpod server
        if (data.success === true) {
          //set job_id
          const job_id = data.job_id;
          //check response from runpod server
          //when summarize text is completed
          if (
            data.status === "FAILED" ||
            data.status === "CANCELLED" ||
            data.status === "TIMED_OUT" ||
            job_id === null
          ) {
            //hide the spinner
            setSubmitClicked(false);

            //set alert state to show error
            setAlert({
              type: "danger",
              message: "Failed to summarize text. Please try again.",
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT);
          } else {
            //check status for job_id
            checkRunpodJobStatus(job_id);
          }
        } else {
          //hide the spinner
          setSubmitClicked(false);
          //scroll to top
          window.scrollTo(0, 0);
          //set alert state to show error
          setAlert({
            type: "danger",
            message:
              data.message || "Failed to summarize text. Please try again.",
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }

        console.log("Response Data summarizer:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //hide the spinner
        setSubmitClicked(false);
        //set alert state to show error
        setAlert({
          type: "danger",
          message:
            "Failed to summarize text. Please try again. \n" + error.message,
          visible: true,
        });

        //hide
        setTimeout(() => {
          //hide alert after 5 seconds
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
      });
  };

  //update search history
  async function updateSearchHistory() {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the summarized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "INSERT_SEARCH_TO_HISTORY",
        text_searched: summarizeTextsValues.enter_main_text,
        text_result: summarizeTextsValues.summarized_text,
        delay_time: process_time.delayTime,
        execution_time: process_time.executionTime,
        search_type: "SUMMARIZE_TEXT",
      }),
    })
      .then((result) => result.json())
      .then((data) => {
        //reset
        setResultLoaded(false);
      })
      .catch((error) => {
        //reset
        setResultLoaded(false);
      });

    console.log("Update Search History");
  }

  //submit handler for the form
  const onSubmitSummarizeTextsForm = (event) => {
    // Get the textarea value
    event.preventDefault();

    //check if empty string
    if (summarizeTextsValues.enter_main_text.length <= MIN_AI_TEXT_LENGTH) {
      //show error
      //set alert state to show error
      setAlert({
        type: "danger",
        message: "Too short text. Please enter atleast 40 characters.",
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);
      //return
      return;
    }

    //check text count
    if (summarizeTextsValues.enter_main_text.length > maxAITextLength) {
      //show warning
      //set alert state to show error
      setAlert({
        type: "warning",
        message:
          "Max character limit exceeded. Input texts will be trimmed before processing.",
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);
      // Update the state with the new value
      setSummarizeTextsValues({
        ...summarizeTextsValues,
        enter_main_text: summarizeTextsValues.enter_main_text.substring(
          0,
          maxAITextLength
        ),
      });
    }

    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  //onvalue change handler for the textarea
  const onChangeSummarizeTextsForm = (event) => {
    // Update the state with the new value
    setSummarizeTextsValues({
      ...summarizeTextsValues,
      [event.target.id]: event.target.value,
    });
  };

  return (
    <div className="p-3">
      <div className="container">
        <div style={{ marginTop: "6rem" }}>
          {/* Alert for failure */}
          <div
            className={`alert alert-${alert.type} ${
              alert.visible ? "" : "d-none"
            } fade show`}
            role="alert"
            style={{ marginTop: "5rem" }}
          >
            {alert.message}
          </div>

          <h1 className="display-6 text-center mt-2">Summarize Texts</h1>
          <p className="text-center lead mt-4">
            Quickly generate concise and accurate summaries of any text with our
            free online AI text summarizer. Perfect for students, writers,
            researchers, and professionals who need to summarize articles,
            essays, documents, or web content. Save time and boost productivity
            with our fast and reliable automatic text summarization tool.
            <strong>
              This text summarizer tool is the best text summarizer available
              for free online.
            </strong>
          </p>

          {/* Input Texts to Summarize */}
          <form onSubmit={onSubmitSummarizeTextsForm}>
            <div className="container mt-5">
              {/* Mode selection */}
              <div className="bg-light p-3 rounded-2">
                <div>
                  <h6 className="ms-2">Select summary lenght:</h6>
                </div>

                {/* Mode selection buttons */}
                <div
                  className="btn-group ms-2 mt-2 flex-wrap"
                  role="group"
                  aria-label="Mode Selection"
                  style={{ width: "100%" }}
                >
                  <button
                    type="button"
                    className={
                      summarizeTextsValues.mode === 1
                        ? `btn btn-secondary mx-2 rounded-2 text-light my-1`
                        : `btn btn-outlined-secondary mx-2 rounded-2 border-secondary my-1`
                    }
                    onClick={(e) => {
                      //blur
                      e.target.blur();
                      //set mode
                      setSummarizeTextsValues({
                        ...summarizeTextsValues,
                        mode: 1,
                      });
                    }}
                  >
                    Short
                  </button>
                  <button
                    type="button"
                    className={
                      summarizeTextsValues.mode === 2
                        ? `btn btn-secondary mx-2 rounded-2 text-light my-1`
                        : `btn btn-outlined-secondary mx-2 rounded-2 border-secondary my-1`
                    }
                    onClick={(e) => {
                      //blur
                      e.target.blur();
                      //set mode
                      setSummarizeTextsValues({
                        ...summarizeTextsValues,
                        mode: 2,
                      });
                    }}
                  >
                    Medium
                  </button>
                  <button
                    type="button"
                    className={
                      summarizeTextsValues.mode === 3
                        ? `btn btn-secondary mx-2 rounded-2 text-light my-1`
                        : `btn btn-outlined-secondary mx-2 rounded-2 border-secondary my-1`
                    }
                    onClick={(e) => {
                      //blur
                      e.target.blur();
                      //set mode
                      setSummarizeTextsValues({
                        ...summarizeTextsValues,
                        mode: 3,
                      });
                    }}
                  >
                    Long
                  </button>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-lg-6 col-sm-12">
                  <div className="position-relative">
                    <textarea
                      className="form-control m-2 shadow"
                      id="enter_main_text"
                      rows="18"
                      style={{ resize: "none" }}
                      placeholder="Insert texts to summarize..."
                      onChange={onChangeSummarizeTextsForm}
                      value={summarizeTextsValues.enter_main_text}
                    ></textarea>
                    <p
                      className="text-center position-absolute ms-4 mb-2 bg-light p-2 rounded"
                      style={{ bottom: "0px" }}
                    >
                      <span
                        className={`${
                          summarizeTextsValues.enter_main_text.length <=
                          MIN_AI_TEXT_LENGTH
                            ? "text-danger"
                            : ""
                        }`}
                      >
                        {summarizeTextsValues.enter_main_text.length}
                      </span>{" "}
                      / {maxAITextLength} Characters
                    </p>

                    {/* CLEAR TEXT & PASTE TEXT buttons */}
                    <div
                      className="position-absolute me-2 mb-3 d-flex bg-light"
                      style={{ right: "0px", bottom: "0px" }}
                    >
                      {/*  paste from clipboard */}
                      <button
                        className="btn btn-outline-success btn-sm me-2"
                        type="button"
                        onClick={(e) => {
                          //text from clipboard
                          navigator.clipboard
                            .readText()
                            .then((text) => {
                              //set text
                              setSummarizeTextsValues({
                                ...summarizeTextsValues,
                                enter_main_text: text,
                              });
                            })
                            .catch((err) => {
                              console.error(
                                "Failed to read clipboard contents: ",
                                err
                              );
                            });
                          // Remove focus after click
                          e.currentTarget.blur();
                        }}
                      >
                        <i className="bi bi-clipboard me-lg-2 me-sm-0"></i>
                        <span className="d-none d-sm-inline">Paste Texts</span>
                      </button>

                      {/* clear text area */}
                      <button
                        className="btn btn-outline-danger btn-sm"
                        type="button"
                        onClick={(e) => {
                          //clear
                          setSummarizeTextsValues({
                            enter_main_text: "",
                            summarized_text: "",
                          });
                          // Remove focus after click
                          e.currentTarget.blur();
                        }}
                      >
                        <i className="bi bi-trash3 me-lg-2 me-sm-0"></i>
                        <span className="d-none d-sm-inline">Clear Text</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                  <div className="position-relative">
                    {/* Waiting time */}
                    <div
                      className={`position-absolute ${
                        submitClicked ? "" : "d-none"
                      }`}
                      style={{
                        left: "0px",
                        right: "0px",
                        margin: "auto",
                        top: "0px",
                        bottom: "0px",
                        width: "200px",
                        height: "100px",
                      }}
                    >
                      {/*Gray box */}
                      <div className="bg-secondary rounded-3 p-1">
                        <label
                          className="fs-5 text-light text-center"
                          style={{ width: "100%" }}
                        >
                          Waiting time:
                        </label>
                        <label
                          className="fs-3 text-light text-center"
                          style={{ width: "100%" }}
                        >
                          {formatSecondsToMS(time)}
                        </label>
                      </div>
                      {/* Text upgrade */}
                      <div className="bg-white bg-opacity-10">
                        <label className="text-muted text-center mt-2">
                          <span>
                            <button
                              className="btn btn-light"
                              type="button"
                              onClick={(e) => {
                                //blur
                                e.currentTarget.blur();
                                //go to pricing page
                                navigate("/pricing"); //Navigate to pricing page
                              }}
                            >
                              Upgrade
                            </button>
                          </span>{" "}
                          for quicker response time
                        </label>
                      </div>
                    </div>
                    <textarea
                      className="form-control m-2 shadow"
                      id="summarized_text"
                      rows="18"
                      style={{ resize: "none" }}
                      placeholder="Summarized text will appear here..."
                      onChange={onChangeSummarizeTextsForm}
                      value={summarizeTextsValues.summarized_text}
                    ></textarea>

                    {/* Copy text */}
                    <div
                      className="position-absolute d-flex me-2 mb-3 bg-light"
                      style={{ right: "0px", bottom: "0px" }}
                    >
                      {/*  copy to clipboard */}
                      <button
                        className="btn btn-outline-dark btn-sm"
                        type="button"
                        onClick={(e) => {
                          //blur
                          e.target.blur();
                          //copy
                          copyTextToClipboard(
                            summarizeTextsValues.summarized_text
                          );
                        }}
                      >
                        <i className="bi bi-clipboard2-check me-2"></i>Copy
                        Texts
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* button to summarize text */}
              <div className="text-center mt-5 justify-content-center d-flex">
                <div
                  className={`spinner-border text-dark me-3 align-self-center ${
                    submitClicked ? "" : "d-none"
                  }`}
                  role="status"
                >
                  <span className="sr-only"></span>
                </div>
                <button
                  className="btn btn-success px-4 py-3 fs-5"
                  disabled={submitClicked}
                  type="submit"
                  style={{
                    backgroundColor: submitClicked
                      ? "#6c757d"
                      : ThemeButtonSummaryBG,
                  }}
                  onClick={(e) => {
                    //blur
                    e.currentTarget.blur();
                    //reset output
                    setSummarizeTextsValues({
                      ...summarizeTextsValues,
                      summarized_text: "",
                    });
                  }}
                >
                  <img
                    src="./images/pen.png"
                    alt="Summarize Text"
                    className="img-fluid"
                    style={{
                      width: "2rem",
                      height: "2rem",
                      marginRight: "0.5rem",
                    }}
                  />{" "}
                  Summarize Text
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SummarizerContent;
